import { Box, Tab, Tabs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const WidgetContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMaximized',
})<{ isMaximized?: boolean }>(({ isMaximized }) => ({
  backgroundColor: '#FEFEFE',
  borderRadius: '1rem',
  border: 'none',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  padding: '1rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100%',
  minHeight: 0,

  ...(isMaximized
    ? {
        fontSize: '0.8rem',
        lineHeight: 1.4,
        fontWeight: 400,
        '&& .MuiTypography-root': {
          fontSize: 'inherit !important',
          lineHeight: 'inherit',
        },
        '&& p, && span, && div, && li, && td, && th, && label': {
          fontSize: 'inherit',
        },
        '&& .MuiChip-label': {
          fontSize: '0.75rem !important',
        },
        '&& .MuiButton-root, && .MuiMenuItem-root, && .MuiInputBase-input': {
          fontSize: 'inherit !important',
        },
      }
    : {
        fontSize: '0.875rem',
      }),
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 0,
  backgroundColor: theme.palette.grey[50],
  borderRadius: '2.25rem',
  marginBottom: '1rem',
  padding: '0.2rem',

  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 0,
  padding: '0.25rem 0.5rem',
  borderRadius: '2.125rem',
  width: 'calc(50% - 0.2rem)',

  textTransform: 'none',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: '160%',
  color: `${theme.palette.grey[800]} !important`,

  '&.Mui-selected': {
    backgroundColor: 'white',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },

  '& svg': {
    height: '1rem',
    width: '1rem',
    marginRight: '0.25rem !important',
  },
}));

export const TabContent = styled(Box)(() => ({
  flex: 1,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const SplitView = styled(Box)(() => ({
  display: 'flex',
  gap: '1rem',
  height: '100%',
  minHeight: 0,
}));

export const SplitColumn = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '1rem',
  paddingRight: '1rem',
}));

export const SplitTitle = styled(Box)(({ theme }) => ({
  padding: '0.75rem 1rem',
  fontWeight: 500,
  flex: '0 0 auto',
  color: theme.palette.grey[900],
}));

export const SplitBody = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const SplitHeaderTitles = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: '1rem',
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
}));

export const SplitHeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1rem',
  color: theme.palette.grey[950],
  textRendering: 'geometricPrecision',
}));
